import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ActionsMenuItem = ({ isDisplayed, onClick, text, isDownload, name }) => {
  if (!isDisplayed) { return null; }

  return (
    <li className={classnames(`actions-menu__${name}`, { 'action-download': isDownload })}>
      <button
        type="button"
        onClick={onClick}
      >
        {isDownload ? (
          <span className="actions-menu__icon bff-download-asset" />
        ) : null}
        {text}
      </button>
    </li>
  );
};

ActionsMenuItem.propTypes = {
  isDisplayed: PropTypes.bool,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDownload: PropTypes.bool,
  name: PropTypes.string,
};

ActionsMenuItem.defaultProps = {
  isDisplayed: true,
  isDownload: false,
  name: '',
};

export default ActionsMenuItem;
